import React from "react"; 
import { Link } from "react-router-dom";    
import EditProductForm from "../../../components/Dashboard/ProductsListContent/Edit";

const EditProduct = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Product</h5>

        <ul className="breadcrumb">
          <li>  
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard     
            </Link>
          </li>
          <li>Products List</li>
          <li>Edit Product</li>
        </ul>
      </div> */}

      <EditProductForm />
    </>
  );
};

export default EditProduct;
